"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EmblemFrame = void 0;

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AVATAR_SIZE = 12;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      position: 'relative',
      marginTop: theme.spacing(AVATAR_SIZE / 2 + 1)
    },
    container: {
      height: '100%',
      padding: theme.spacing(AVATAR_SIZE / 2),
      borderColor: function borderColor(_ref) {
        var _borderColor = _ref.borderColor;
        return _borderColor || theme.palette.grey[400];
      },
      borderStyle: 'solid',
      borderWidth: 2
    },
    avatar: {
      height: theme.spacing(AVATAR_SIZE),
      width: theme.spacing(AVATAR_SIZE),
      position: 'absolute',
      left: "calc(50% - ".concat(theme.spacing(AVATAR_SIZE / 2), "px)"),
      top: -theme.spacing(AVATAR_SIZE / 2),
      backgroundColor: theme.palette.background.paper,
      borderColor: function borderColor(_ref2) {
        var _borderColor2 = _ref2.borderColor;
        return _borderColor2 || theme.palette.grey[400];
      },
      borderWidth: 2,
      borderStyle: 'solid'
    },
    avatarIcon: {
      width: theme.spacing(AVATAR_SIZE * 0.7),
      height: theme.spacing(AVATAR_SIZE * 0.7),
      fill: theme.palette.primary.main
    }
  };
});

var EmblemFrame = function EmblemFrame(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      borderColor = _ref3.borderColor,
      icon = _ref3.icon,
      _ref3$iconProps = _ref3.iconProps,
      iconProps = _ref3$iconProps === void 0 ? {} : _ref3$iconProps,
      props = _objectWithoutProperties(_ref3, ["className", "children", "borderColor", "icon", "iconProps"]);

  var classes = useStyles({
    borderColor: borderColor
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: classes.avatar
  }, /*#__PURE__*/_react.default.createElement(_core.SvgIcon, _extends({
    component: icon,
    className: classes.avatarIcon
  }, iconProps))), /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: classes.container
  }, children));
};

exports.EmblemFrame = EmblemFrame;
EmblemFrame.propTypes = {
  icon: _propTypes.default.func.isRequired,
  borderColor: _propTypes.default.string,
  iconProps: _propTypes.default.object
};
var _default = EmblemFrame;
exports.default = _default;